import { Component, h, Host, Prop, State, Method, Listen } from '@stencil/core';
import { $$$ } from '../../../utils/utils';
import axios from '../../../utils/get-axios';
import { LiluQuantityButton } from '../lilu-quantity-button/lilu-quantity-button';

const ACC = (window as any).ACC;
@Component({
  tag: 'lilu-mini-basket',
  styleUrl: 'lilu-mini-basket.scss',
  shadow: true,
})
export class LiluMiniBasket {
  @Prop() currentcount = 0;
  @Prop() basketelement = '';
  @Prop() notificationelement = '';
  @Prop() timeout: any;
  @Prop() quantityButtons: any[] = [];
  @Prop() CSRFToken?: any;
  @Prop() modal: any;
  @Prop() modalContent: any;
  @Prop() title = '';
  @State() open = false;
  @State() isBodyAtTop = true;

  tokenHeader: any = null;

  private toggleMiniBasket() {
    this.open = !this.open;

    if (this.open) {
      this.hideNotification();
    } else {
      for (let item of this.quantityButtons) {
        if (typeof item !== 'undefined' && typeof item.basketId !== 'undefined') {
          this.unregisterAddToCartButton(item.basketId);
        }
      }
    }
  }

  getBasket: any = () => {
    return <div innerHTML={this.basketelement}></div>;
  };

  getNotification: any = () => {
    return <div innerHTML={this.notificationelement}></div>;
  };

  showNotification: any = () => {
    this.clearNotificationTimeout();
    if (window.screen.width >= 576) {
      this.timeout = setTimeout(function (this) {
        $$$('.basket-notification-container')[0].style.display = 'none';
      }, 4000);
      $$$('.basket-notification-container')[0].style.display = 'inline';
    }
  };

  hideNotification: any = () => {
    $$$('.basket-notification-container')[0].style.display = 'none';
  };

  clearNotificationTimeout: any = () => {
    clearTimeout(this.timeout);
  };

  @Method()
  async addProductToBasket(url, productId, storeId, productAddedCallback = _ => {}, addErrorCallback = _ => {}) {
    this.currentcount++;

    url = `${url}/add/${storeId ? `${storeId}/` : ''}${productId ? `${productId}/` : ''}`;

    /* @TODO - Check if this is needed...
    const storefinder = document.querySelector('lilu-storfinder');
    let dataUrl = '';

    if (storeId !== '') {
      dataUrl = storefinder.getAttribute('data-url');
      url = `${dataUrl}/${storeId}/${productId}/`;
    } else {
      url = `${url}/add/${storeId ? `${storeId}/` : ''}${productId ? `${productId}/` : ''}`;
    }
    */

    url = url.replace('//', '/');

    axios
      .post(url, '', this.tokenHeader)
      .then(response => {
        if (response.data.modal !== null && response.data.modal.html !== '') {
          this.modal = document.querySelector(`[data-modal="default"]`);
          this.modalContent = document.querySelector(`[data-modal="default"] .content`);
          this.modalContent.innerHTML = response.data.modal.html;
          this.modal.open();
        }

        this.updateMiniBasketHTML(response);
        this.showNotification();
        productAddedCallback({ productId: response.data.items[0].id, success: response.data.success });
      })
      .catch(error => {
        addErrorCallback(error);
      });
  }

  setPDPBtnsLoading(isLoading: boolean) {
    const btnToUpdate = $$$('lilu-quantity-button').concat($$$('.cta > lilu-button'));

    btnToUpdate.forEach(element => {
      element.setIsLoading(isLoading);
    });
  }

  @Method()
  async updateProductFromBasket(url: string, productId: number, quantity: number, cartUpdatedCallback = _ => {}, updateErrorCallback = _ => {}) {
    url = `${url}/update/${productId}/${quantity}`;

    this.setPDPBtnsLoading(true);

    axios
      .post(url, '', this.tokenHeader)
      .then(response => {
        this.updateMiniBasketHTML(response);
        if (response.data.items) {
          cartUpdatedCallback({ productId: response.data.items[0].id, success: response.data.success });
          if (response.data.items[0].qty === '0') {
            const quantityBtn = document.querySelector(`lilu-quantity-button[uid="${response.data.items[0].id}"]`) as unknown as LiluQuantityButton;
            quantityBtn?.setAmount(0);
          }
        }
      })
      .catch(error => {
        console.error('updateProductFromBasket axios error', error);
        updateErrorCallback(error);
      })
      .finally(() => {
        this.setPDPBtnsLoading(false);
      });
  }

  @Method()
  async changeProductFromBasket(url: string, cartChangeCallback = _ => {}, changeErrorCallback = _ => {}) {
    axios
      .post(url, '', this.tokenHeader)
      .then(response => {
        this.updateMiniBasketHTML(response);
        if (response.data.items) {
          cartChangeCallback(response.data.items[0].id);
          if (response.data.items[0].qty === '0') {
            document.querySelector(`lilu-quantity-button[uid="${response.data.items[0].id}"]`)?.setAttribute('amount', response.data.items[0].qty);
          }
        }
      })
      .catch(error => {
        console.error('changeProductFromBasket axios error', error);
        changeErrorCallback(error);
      });
  }

  @Method()
  async registerAddToCartButton(button) {
    this.quantityButtons.push(button);
    return this.quantityButtons.length - 1;
  }

  @Method()
  async unregisterAddToCartButton(id) {
    delete this.quantityButtons[id];
  }

  @Listen('scroll', { target: 'window' })
  onScroll() {
    this.isBodyAtTop = window.scrollY === 0;
  }

  // --------------------------------------------------------------------------------------------
  // --------------------------------------------------------------------------------------------

  async updateBtnAmountAndId(itemInResponse, selector: string) {
    if (itemInResponse && itemInResponse.uid) {
      // update the data of the btn
      const button = document.querySelector(selector);
      if (button) {
        button.setAttribute('amount', itemInResponse.quantity);
        button.setAttribute('uid', itemInResponse.uid);
      }
    }
  }

  async updateMiniBasketHTML(response) {
    const minibasketHTML = response.data.liluMiniBaseketFlyOut;

    this.basketelement = minibasketHTML;
    this.currentcount = response.data.liluItemCount;

    if (response.data.items && response.data.items[0].html.notification) {
      this.notificationelement = response.data.items[0].html.notification;
    }

    const warenkorbElement = $$$('lilu-checkout-warenkorb-wrapper')[0];

    if (warenkorbElement) {
      warenkorbElement.changeBasketContentFromOutside(response);
    }

    this.updateBtnAmountAndId(response.data.deliveryItem, 'lilu-tabs > lilu-quantity-button#deliver-button');
    this.updateBtnAmountAndId(response.data.pickUpItem, 'lilu-tabs > lilu-quantity-button#pickup-button');
  }

  // --------------------------------------------------------------------------------------------
  // --------------------------------------------------------------------------------------------

  onRemoveClickHandlerBindArray = new Array();

  componentDidUpdate() {
    if (this.notificationelement !== '') {
      $$$('.close-item')[0].addEventListener('click', () => this.hideNotification());
    }

    const remove: HTMLElement[] = $$$('.remove-item');
    remove.forEach(item => {
      if (!item.getAttribute('clickable')) {
        const onRemoveClickHandlerBind = this.onRemoveClickHandler.bind(this, item);
        this.onRemoveClickHandlerBindArray.push(onRemoveClickHandlerBind);
        this.onRemoveClickHandlerBindArray.forEach(onRemoveClickHandlerBindEvent => item.removeEventListener('click', onRemoveClickHandlerBindEvent));
        item.addEventListener('click', onRemoveClickHandlerBind, false);
      }
    });
  }

  onRemoveClickHandler(item: HTMLElement) {
    this.updateProductFromBasket(`${this.getCartURL()}/detail`, parseInt(item.getAttribute('data-id')), 0);
  }

  getCartURL(): string {
    // expect to have the language first as in https://qual-lilu.livique.ch/fr/cart
    const currentPathName = new URL(document.URL).pathname.split('/');
    if (currentPathName.length > 0 && ['fr', 'de', 'it', 'en'].includes(currentPathName[1].toLowerCase())) {
      return `/${currentPathName[1]}/cart`;
    } else {
      return '/de/cart';
    }
  }

  componentDidLoad() {
    if (ACC !== undefined) {
      this.tokenHeader = {
        headers: { CSRFToken: ACC.config.CSRFToken },
      };
    }

    $$$('body')[0].addEventListener('click', event => {
      if (this.open) {
        const isClickInside = $$$('lilu-mini-basket')[0].contains(event.target);

        if (!isClickInside) {
          this.toggleMiniBasket();
        }
      }
    });
  }

  render() {
    return (
      <Host>
        <div
          class={`mini-basket-container ${!this.isBodyAtTop ? 'small-header' : ''} ${this.open ? 'open' : ''}`}
          onMouseOver={() => {
            this.open = true;
          }}
          onMouseOut={() => {
            this.open = false;
          }}
        >
          <lilu-link
            class="desktop-basket"
            color="dark"
            appearance="uppercase font-minus-4"
            icon={this.currentcount < 1 ? 'icon-cart' : ' icon-cart-filled'}
            link={this.getCartURL()}
            target="_self"
            size="size-18"
            font="bold"
          >
            {this.currentcount > 0 ? this.currentcount : ''} {this.title.toUpperCase()}
          </lilu-link>
          <lilu-link
            class="mobile-basket"
            color="dark"
            appearance="uppercase font-minus-4"
            icon={this.currentcount < 1 ? 'icon-cart' : ' icon-cart-filled'}
            link={this.getCartURL()}
            target="_self"
            size="size-16"
            font="bold"
          >
            {this.currentcount > 0 ? this.currentcount : ''}
          </lilu-link>
          <div class="basket-content">{this.open && this.currentcount > 0 ? this.getBasket() : null}</div>
          <div class="basket-notification-container">{this.notificationelement !== '' ? this.getNotification() : null}</div>
        </div>
      </Host>
    );
  }
}
